var _g, _ellipse, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPendingMessageVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 391.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "background-complete--inject-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 327.4,
    width: 500,
    height: 0.25,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.04,
    y: 333.78,
    width: 23.18,
    height: 0.25,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.1,
    y: 339.14,
    width: 56.67,
    height: 0.25,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.72,
    y: 339.14,
    width: 56.67,
    height: 0.25,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,282.8H43.91c-3.15,0-5.7-2.56-5.7-5.71V5.66c.03-3.13,2.57-5.65,5.7-5.66H237c3.15,0,5.71,2.56,5.71,5.71h0V277.09c0,3.15-2.56,5.71-5.71,5.71ZM43.91,.2c-3.01,0-5.45,2.45-5.45,5.46V277.09c0,3.01,2.44,5.45,5.45,5.46H237c3.01,0,5.45-2.45,5.46-5.46V5.66c0-3.01-2.45-5.45-5.46-5.46H43.91Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,282.8h-193.1c-3.15,0-5.7-2.56-5.71-5.71V5.66c.03-3.13,2.58-5.65,5.71-5.66h193.1c3.13,.01,5.66,2.53,5.69,5.66V277.09c0,3.15-2.54,5.7-5.69,5.71ZM260.21,.2c-3.01,0-5.45,2.45-5.46,5.46V277.09c0,3.01,2.45,5.45,5.46,5.46h193.1c3.01,0,5.45-2.45,5.46-5.46V5.66c0-3.01-2.45-5.45-5.46-5.46h-193.1Z",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 429.04,
    y: 358.31,
    width: 21.6,
    height: 0.25,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M468.14,238.29c-2.09-5.99-18.59,2.16-25.23,12.09-4.45,6.61-7.17,13.68-8.43,23.16,.15-10.84,.33-22.46,.49-33.42,1.36-2.73,4.44-9.05,6.66-14.04,7.4-16.68,25.01-22.88,31.08-33.42,7.97-13.8,7.92-34.49,1.14-41.96-5.89-6.49-25.42,37.39-27.62,42.29-7.56,16.87-9.76,29.38-11.17,41.5,.15-10.31,.31-19.76,.44-27.1,.41-23.81,.93-31.47,1.16-33.83,.82-1.15,1.78-2.49,2.32-3.21,4.72-6.08,15.21-13.32,20.44-22.16,7.65-12.91,6.41-28.36,1.05-34.07-5.61-6.02-15.53,8.2-20.78,22.29-5.26,14.09-3.02,27.57-4.49,39.27-.31,2.32-.63,11.01-.93,23.1-1.6-13.01-4.78-21.72-10.67-29.85-7.26-9.99-13.51-22.15-19.49-20.58-5.98,1.57-2.76,17.66,1.97,28.96,4.2,10.07,24.97,20.1,28.03,28.18-.36,16.39-.68,37.17-.91,56.48-1.63-9.98-.51-10.84-7.22-26.11-3.99-9.09-20.34-20.3-22.29-14.05-1.92,6.13,1.01,18.04,7.19,26.33,4.98,6.67,16.03,6.66,18.59,10.8,.6,.97,2.56,4.65,3.69,6.79-.27,23.6-.39,44.43-.26,51.53l1.07,.07c-.05-1.83,.09-13.83,.29-29.72,2.68-8.45,20.75-13.38,26.33-22.17,5.85-9.22,10.04-19.96,7.54-27.15Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.15,327.94h-34.66c-1.88-.01-3.5-1.34-3.87-3.19l-2.46-12.13h47.39l-2.46,12.13c-.38,1.87-2.03,3.21-3.93,3.19Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.51,317.31h-49.38c-1.19,0-2.19-.88-2.32-2.06l-1.01-8.97c-.15-1.27,.77-2.43,2.04-2.57,.09-.01,.19-.02,.28-.01h51.4c1.28,0,2.33,1.03,2.34,2.31,0,.09,0,.19-.01,.28l-1.02,8.95c-.13,1.18-1.13,2.08-2.32,2.08Z",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 52.91,
    y: 34.01,
    width: 69.8,
    height: 76.64,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.84,
    y: 34.01,
    width: 74.84,
    height: 76.64,
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.61,
    y: 38.78,
    width: 65.3,
    height: 67.09,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.48,96.19h0c-7.78-7.77-7.78-20.38-.01-28.16h.01s19.55-19.56,19.55-19.56h0c7.77,7.78,7.77,20.39,0,28.17l-19.55,19.55Z",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.94,
    y: 151.06,
    width: 47.51,
    height: 53.62,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.1,
    y: 151.06,
    width: 53.22,
    height: 53.62,
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.6,
    y: 156.55,
    width: 42.24,
    height: 42.65,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.88,
    y: 169.05,
    width: 17.65,
    height: 17.65,
    rx: 5.4,
    ry: 5.4,
    transform: "translate(-101.85 109.87) rotate(-45)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 184.21,
    y: 218.04,
    width: 21.65,
    height: 109.21,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.8,
    y: 218.05,
    width: 93.41,
    height: 109.21,
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.31,
    y: 260.06,
    width: 76.39,
    height: 25.17,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.31,
    y: 290.85,
    width: 76.39,
    height: 25.17,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.92,263.44h17.15c1.16,0,2.1-.95,2.11-2.11h0c0-1.17-.94-2.11-2.11-2.12h-17.15c-1.17,0-2.11,.95-2.11,2.12h0c0,1.16,.95,2.1,2.11,2.11Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.31,
    y: 229.28,
    width: 76.39,
    height: 25.17,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.92,232.65h17.15c1.17,0,2.11-.95,2.11-2.12h0c0-1.16-.95-2.1-2.11-2.11h-17.15c-1.16,0-2.1,.95-2.11,2.11h0c0,1.17,.94,2.11,2.11,2.12Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.92,294.23h17.15c1.17,0,2.11-.95,2.11-2.12h0c0-1.16-.95-2.1-2.11-2.11h-17.15c-1.16,0-2.1,.95-2.11,2.11h0c0,1.17,.94,2.11,2.11,2.12Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.91,
    y: 212.3,
    width: 96.3,
    height: 5.74,
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.21,
    y: 212.31,
    width: 24.67,
    height: 5.74,
    fill: "#e0e0e0"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 377.82,
    rx: 175.17,
    ry: 13.82,
    fill: "#f5f5f5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M397.64,73.83c-1.44-4.77-3.35-9.39-5.7-13.79h0l3.55-11.63-22.94-22.94-11.64,3.57h0c-4.38-2.38-9-4.29-13.78-5.71h0l-5.7-10.73h-32.48l-5.71,10.73c-4.78,1.43-9.39,3.34-13.78,5.71h0l-11.63-3.57-22.97,22.97,3.55,11.63h0c-2.36,4.39-4.27,9.01-5.7,13.79l-10.74,5.7v32.48l10.73,5.71h0c1.43,4.77,3.34,9.39,5.7,13.78h0l-3.55,11.61,22.97,22.97,11.63-3.55c4.39,2.36,9.01,4.27,13.79,5.69l5.71,10.74h32.48l5.7-10.73h0c4.77-1.43,9.39-3.35,13.78-5.71l11.64,3.55,22.97-22.97-3.55-11.63h0c2.34-4.39,4.24-9.01,5.68-13.78h0l10.73-5.71v-32.48l-10.73-5.7Zm-72.46,80.83c-32.52,0-58.89-26.37-58.89-58.89s26.37-58.89,58.89-58.89,58.89,26.37,58.89,58.89-26.37,58.89-58.89,58.89h0Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.18,45.14c-27.97,0-50.64,22.69-50.63,50.66,0,27.97,22.69,50.64,50.66,50.63,27.96,0,50.63-22.68,50.63-50.64-.03-27.96-22.7-50.62-50.66-50.64Zm0,94.54c-24.24,0-43.9-19.64-43.91-43.89,0-24.24,19.64-43.9,43.89-43.91,24.24,0,43.9,19.64,43.91,43.89h0c-.03,24.24-19.66,43.88-43.89,43.91Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.64,73.83c-1.44-4.77-3.35-9.39-5.7-13.79h0l3.55-11.63-22.94-22.94-11.64,3.57h0c-4.38-2.38-9-4.29-13.78-5.71h0l-5.7-10.73h-32.48l-5.71,10.73c-4.78,1.43-9.39,3.34-13.78,5.71h0l-11.63-3.57-22.97,22.97,3.55,11.63h0c-2.36,4.39-4.27,9.01-5.7,13.79l-10.74,5.7v32.48l10.73,5.71h0c1.43,4.77,3.34,9.39,5.7,13.78h0l-3.55,11.61,22.97,22.97,11.63-3.55c4.39,2.36,9.01,4.27,13.79,5.69l5.71,10.74h32.48l5.7-10.73h0c4.77-1.43,9.39-3.35,13.78-5.71l11.64,3.55,22.97-22.97-3.55-11.63h0c2.34-4.39,4.24-9.01,5.68-13.78h0l10.73-5.71v-32.48l-10.73-5.7Zm-72.46,80.83c-32.52,0-58.89-26.37-58.89-58.89s26.37-58.89,58.89-58.89,58.89,26.37,58.89,58.89-26.37,58.89-58.89,58.89h0Z",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.18,45.14c-27.97,0-50.64,22.69-50.63,50.66,0,27.97,22.69,50.64,50.66,50.63,27.96,0,50.63-22.68,50.63-50.64-.03-27.96-22.7-50.62-50.66-50.64Zm0,94.54c-24.24,0-43.9-19.64-43.91-43.89,0-24.24,19.64-43.9,43.89-43.91,24.24,0,43.9,19.64,43.91,43.89h0c-.03,24.24-19.66,43.88-43.89,43.91Z",
    fill: "#fff",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M193.32,138.12c-.77-2.53-1.78-4.98-3.03-7.31l1.88-6.17-12.18-12.19-6.17,1.88c-2.33-1.25-4.78-2.27-7.31-3.03l-3.03-5.65h-17.24l-3.02,5.65c-2.53,.76-4.98,1.78-7.31,3.03l-6.17-1.88-12.19,12.19,1.88,6.17c-1.24,2.33-2.26,4.78-3.02,7.31l-5.7,3.03v17.24l5.7,3.02c.77,2.53,1.78,4.98,3.02,7.31l-1.88,6.17,12.19,12.19,6.17-1.88c2.33,1.25,4.78,2.26,7.31,3.02l3.02,5.65h17.24l3.03-5.65c2.53-.77,4.98-1.78,7.31-3.02l6.17,1.88,12.19-12.19-1.88-6.17c1.25-2.33,2.27-4.78,3.03-7.31l5.7-3.02v-17.24l-5.71-3.03Zm-38.45,36.13c-13.52,0-24.49-10.96-24.49-24.49s10.96-24.49,24.49-24.49,24.49,10.96,24.49,24.49-10.96,24.49-24.49,24.49h0Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M193.32,138.12c-.77-2.53-1.78-4.98-3.03-7.31l1.88-6.17-12.18-12.19-6.17,1.88c-2.33-1.25-4.78-2.27-7.31-3.03l-3.03-5.65h-17.24l-3.02,5.65c-2.53,.76-4.98,1.78-7.31,3.03l-6.17-1.88-12.19,12.19,1.88,6.17c-1.24,2.33-2.26,4.78-3.02,7.31l-5.7,3.03v17.24l5.7,3.02c.77,2.53,1.78,4.98,3.02,7.31l-1.88,6.17,12.19,12.19,6.17-1.88c2.33,1.25,4.78,2.26,7.31,3.02l3.02,5.65h17.24l3.03-5.65c2.53-.77,4.98-1.78,7.31-3.02l6.17,1.88,12.19-12.19-1.88-6.17c1.25-2.33,2.27-4.78,3.03-7.31l5.7-3.02v-17.24l-5.71-3.03Zm-38.45,36.13c-13.52,0-24.49-10.96-24.49-24.49s10.96-24.49,24.49-24.49,24.49,10.96,24.49,24.49-10.96,24.49-24.49,24.49h0Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.86,141.65c-4.48,0-8.12,3.63-8.12,8.12s3.63,8.12,8.12,8.12,8.12-3.63,8.12-8.12h0c0-4.48-3.63-8.12-8.12-8.12Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.32,138.12c-.77-2.53-1.78-4.98-3.03-7.31l1.88-6.17-12.18-12.19-6.17,1.88c-2.33-1.25-4.78-2.27-7.31-3.03l-3.03-5.65h-17.24l-3.02,5.65c-2.53,.76-4.98,1.78-7.31,3.03l-6.17-1.88-12.19,12.19,1.88,6.17c-1.24,2.33-2.26,4.78-3.02,7.31l-5.7,3.03v17.24l5.7,3.02c.77,2.53,1.78,4.98,3.02,7.31l-1.88,6.17,12.19,12.19,6.17-1.88c2.33,1.25,4.78,2.26,7.31,3.02l3.02,5.65h17.24l3.03-5.65c2.53-.77,4.98-1.78,7.31-3.02l6.17,1.88,12.19-12.19-1.88-6.17c1.25-2.33,2.27-4.78,3.03-7.31l5.7-3.02v-17.24l-5.71-3.03Zm-38.45,36.13c-13.52,0-24.49-10.96-24.49-24.49s10.96-24.49,24.49-24.49,24.49,10.96,24.49,24.49-10.96,24.49-24.49,24.49h0Z",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.86,141.65c-4.48,0-8.12,3.63-8.12,8.12s3.63,8.12,8.12,8.12,8.12-3.63,8.12-8.12h0c0-4.48-3.63-8.12-8.12-8.12Z",
    fill: "#fff",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M209.04,122.49l-6.59-2.72-.24-2.48c-.62-.52-1.19-1.09-1.71-1.7l-2.47-.24-2.72-6.59,1.58-1.88c-.07-.81-.07-1.62,0-2.43l-1.58-1.88,2.72-6.59,2.47-.24c.53-.61,1.1-1.19,1.71-1.71l.24-2.47,6.59-2.72,1.88,1.58c.81-.07,1.62-.07,2.43,0l1.88-1.58,6.59,2.72,.24,2.47c.61,.53,1.19,1.1,1.71,1.71l2.47,.24,2.72,6.59-1.58,1.88c.07,.81,.07,1.62,0,2.43l1.58,1.88-2.72,6.59-2.47,.24c-.52,.62-1.1,1.19-1.71,1.71l-.24,2.47-6.59,2.72-1.88-1.58c-.81,.07-1.61,.07-2.42,0l-1.89,1.58Zm4.78-3.04l1.71,1.41,5-2.07,.21-2.2,.24-.19c.7-.57,1.35-1.2,1.93-1.88l.18-.24,2.21-.21,2.07-5-1.41-1.71v-.29c.09-.91,.09-1.82,0-2.73v-.29l1.41-1.71-2.07-5-2.2-.21-.19-.24c-.58-.69-1.23-1.32-1.93-1.88l-.24-.19-.21-2.2-5-2.07-1.71,1.41h-.29c-.91-.09-1.82-.09-2.73,0h-.29l-1.71-1.41-5,2.07-.21,2.2-.23,.19c-.71,.56-1.36,1.19-1.94,1.88l-.19,.24-2.2,.21-2.09,4.96,1.41,1.71v.29c-.09,.91-.09,1.82,0,2.73v.29l-1.41,1.71,2.07,5,2.2,.21,.19,.23c.58,.71,1.22,1.35,1.93,1.93l.24,.19,.21,2.21,5,2.07,1.71-1.41h.29c.91,.09,1.82,.09,2.73,0h.31Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.09,112.72c-3.91,1.62-8.39-.24-10-4.14-1.62-3.91,.24-8.39,4.14-10,3.91-1.62,8.39,.24,10,4.14,0,0,0,0,0,0,1.62,3.9-.23,8.38-4.13,10,0,0,0,0-.01,0Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M160.04,106.86c-.26,0-.47-.21-.47-.47v-2.35c0-.26,.21-.47,.47-.47s.47,.21,.47,.47v2.35c0,.26-.21,.47-.47,.47Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.04,99.79c-.26,0-.47-.21-.47-.47v-4.72c0-.26,.21-.47,.47-.47s.47,.21,.47,.47v4.72c0,.26-.21,.47-.47,.47Zm0-9.44c-.26,0-.47-.21-.47-.47v-4.72c0-.26,.21-.47,.47-.47s.47,.21,.47,.47v4.72c0,.26-.21,.47-.47,.47Zm0-9.44c-.26,0-.47-.21-.47-.47v-4.72c0-.26,.21-.47,.47-.47s.47,.21,.47,.47v4.72c0,.26-.21,.47-.47,.47Zm0-9.47c-.26,0-.47-.18-.47-.44v-.07c0-1.62,.27-3.21,.79-4.72,.09-.25,.35-.37,.6-.29,.25,.09,.38,.35,.29,.6-.49,1.41-.74,2.9-.74,4.41,0,.26-.21,.5-.47,.5Zm3.04-8.71c-.1,0-.21-.03-.29-.1-.2-.16-.24-.46-.07-.66,1.02-1.28,2.24-2.36,3.62-3.23,.22-.14,.51-.07,.65,.15,.14,.22,.07,.51-.15,.65-1.29,.81-2.43,1.82-3.39,3.02-.09,.12-.23,.18-.37,.18Zm7.85-4.9c-.22,0-.41-.15-.46-.37-.06-.25,.1-.51,.36-.56,1.02-.23,2.07-.34,3.13-.34h1.67c.26,0,.47,.21,.47,.47s-.21,.47-.47,.47h-1.67c-.99,0-1.97,.11-2.92,.32-.03,0-.07,.01-.1,.01Zm80.19-.33h-4.72c-.26,0-.47-.21-.47-.47s.21-.47,.47-.47h4.72c.26,0,.47,.21,.47,.47s-.21,.47-.47,.47Zm-9.44,0h-4.72c-.26,0-.47-.21-.47-.47s.21-.47,.47-.47h4.72c.26,0,.47,.21,.47,.47s-.21,.47-.47,.47Zm-9.44,0h-4.72c-.26,0-.47-.21-.47-.47s.21-.47,.47-.47h4.72c.26,0,.47,.21,.47,.47s-.21,.47-.47,.47Zm-9.44,0h-4.72c-.26,0-.47-.21-.47-.47s.21-.47,.47-.47h4.72c.26,0,.47,.21,.47,.47s-.21,.47-.47,.47Zm-9.44,0h-4.72c-.26,0-.47-.21-.47-.47s.21-.47,.47-.47h4.72c.26,0,.47,.21,.47,.47s-.21,.47-.47,.47Zm-9.44,0h-4.72c-.26,0-.47-.21-.47-.47s.21-.47,.47-.47h4.72c.26,0,.47,.21,.47,.47s-.21,.47-.47,.47Zm-9.44,0h-4.72c-.26,0-.47-.21-.47-.47s.21-.47,.47-.47h4.72c.26,0,.47,.21,.47,.47s-.21,.47-.47,.47Zm-9.44,0h-4.72c-.26,0-.47-.21-.47-.47s.21-.47,.47-.47h4.72c.26,0,.47,.21,.47,.47s-.21,.47-.47,.47Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.21,57.5h-2.35c-.26,0-.47-.21-.47-.47s.21-.47,.47-.47h2.35c.26,0,.47,.21,.47,.47s-.21,.47-.47,.47Z",
    fill: "#407bff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 159.75,
    y: 222.69,
    width: 4.93,
    height: 154.07,
    transform: "translate(324.44 599.46) rotate(180)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M285.17,280.52h81.42v11.29h-81.42c-2.05,0-3.71-1.66-3.71-3.71v-3.87c0-2.05,1.66-3.71,3.71-3.71Z",
    transform: "translate(648.04 572.32) rotate(180)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 359.74,
    y1: 377.62,
    x2: 353.84,
    y2: 284.37,
    fill: "none",
    stroke: "#407bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.15,
    y1: 382.24,
    x2: 331.25,
    y2: 288.99,
    fill: "none",
    stroke: "#407bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 277.94,
    y1: 377.62,
    x2: 283.84,
    y2: 284.37,
    fill: "none",
    stroke: "#407bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.83
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.53,
    y1: 382.24,
    x2: 306.43,
    y2: 288.99,
    fill: "none",
    stroke: "#407bff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.83
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M292.39,273.08h81.42v11.29h-81.42c-2.05,0-3.71-1.66-3.71-3.71v-3.87c0-2.05,1.66-3.71,3.71-3.71Z",
    transform: "translate(662.49 557.45) rotate(180)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.39,273.08h81.42v11.29h-81.42c-2.05,0-3.71-1.66-3.71-3.71v-3.87c0-2.05,1.66-3.71,3.71-3.71Z",
    transform: "translate(662.49 557.45) rotate(180)",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 288.1,
    y: 226.37,
    width: 4.93,
    height: 154.07,
    transform: "translate(581.13 606.82) rotate(180)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M304.9,238.1s-56.35,2.12-65.71,24.74c0,0,1.3,67.36,8.84,89.47l16.13-1.82-2.58-65.51,58.29-46.88h-14.97Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.9,238.1s-56.35,2.12-65.71,24.74c0,0,1.3,67.36,8.84,89.47l16.13-1.82-2.58-65.51,58.29-46.88h-14.97Z",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "261.48 367.35 251.42 367.35 251.29 360.64 251.18 355.39 261.02 355.98 261.21 360.64 261.48 367.35",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.21 360.64 251.29 360.64 251.18 355.39 261.02 355.98 261.21 360.64",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "265.99 357.52 244.43 358.17 240.5 350.17 265.4 349.94 265.99 357.52",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M248.84,368.87s.51-5.91-1.54-5.09c-2.07,.83,.24,3.84,1.54,5.09Z",
    fill: "none",
    stroke: "#407bff",
    strokeMiterlimit: 10,
    strokeWidth: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.84,368.87s-4.43-3.09-5.56-1.52c-1.12,1.58,5.56,1.52,5.56,1.52Z",
    fill: "none",
    stroke: "#407bff",
    strokeMiterlimit: 10,
    strokeWidth: 0.94
  })), /*#__PURE__*/React.createElement("path", {
    d: "M252.35,365.99l7.96,.08c1.16,.01,2.13,.92,2.22,2.09l.56,7.08c.1,1.31-.93,2.41-2.23,2.37-4.33-.13-13.24-.36-16.4-.27-4.23,.12-10.24,.19-11.1-1.42-.86-1.6,.51-2.66,.51-2.66,0,0,11.52-1.07,16.83-6.55,.44-.45,1.02-.74,1.65-.73Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M355.46,238.1s1.06,13.13,.66,23.28c-.46,11.7-25.65,22.01-62.32,16.03,0,0-2.86,19.77-13,37.97-10.14,18.21-26.01,45.26-26.01,45.26l-15.61-10.14s20.55-56.96,24.45-72.83c3.9-15.87,5.46-23.41,16.65-28.35,11.18-4.94,35.63-11.22,35.63-11.22h39.55Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "248.84 357.66 246.99 360.5 242.92 366.77 235.11 362.22 239.2 355.86 240.79 353.4 248.84 357.66",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.84 357.66 246.99 360.5 239.2 355.86 240.79 353.4 248.84 357.66",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "258.87 355.39 238.42 343.14 235.11 351.31 254.52 362.52 258.87 355.39",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M229.76,362.52s1.49-5.12-.19-5.21c-1.68-.09,.19,5.21,.19,5.21Z",
    fill: "none",
    stroke: "#407bff",
    strokeMiterlimit: 10,
    strokeWidth: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.37,362.33s-2.3-5.56-4.16-4.32c-1.86,1.24,4.16,4.32,4.16,4.32Z",
    fill: "none",
    stroke: "#407bff",
    strokeMiterlimit: 10,
    strokeWidth: 0.94
  })), /*#__PURE__*/React.createElement("path", {
    d: "M236.12,361.66l6.82,4.03c.99,.59,1.37,1.84,.85,2.87l-3.1,6.27c-.57,1.16-2.02,1.58-3.12,.9-3.67-2.26-11.24-6.88-14.01-8.37-3.71-2-8.93-4.93-8.85-6.71,.07-1.79,1.79-2,1.79-2,0,0,10.48,4.82,17.83,2.82,.61-.17,1.25-.12,1.79,.2Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M292.16,180.72s-2.1,22.94-1.25,28.84c0,0-21.92,3.2-33.06,1.69l-7.42-1.86-9.28,2.26,2.53,7.35h7.42s5.4,1.52,7.76,0c0,0,18.55,3.71,29.51,2.53,10.96-1.18,14.36-5.35,14.84-13.66,.47-7.99,5.74-25.82,1.52-29.87l-12.58,2.71Z",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.44,183.3s-8.41-21.36-16.59-26.18c-8.18-4.83-46.05,4.41-46.05,4.41,0,0-16.25,5.23-17.19,30.62l14.93,6.33,2.36,39.63h50.56l-.27-51.33,12.25-3.47Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.48,119.66s-5.01-.62-6.36-4.38c-1.36-3.76,3.86-1.86,3.42-8.64-.44-6.78,7.35-8.41,13.01-5.42,5.66,2.98,14.61-.27,18,3.8,3.39,4.07,1.9,7.86,1.9,7.86,0,0,9.72,10.99-2.6,18.51-12.31,7.52-27.37-11.73-27.37-11.73Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.88,156.21c-5.4,8.23-10.26,9.08-16.78,9.07-7.3-.03-4.86-5.2-4.86-5.2,3.06-1.53,5.29-3.17,5.64-6.94,.07-.76,.09-1.5,.05-2.2-.12-2.8-.87-4.98-.87-4.98-10.35,.94-14-4.12-15.3-13.64-1.29-9.53,3.06-17.05,3.06-17.05,6,7.06,17.29,1.53,17.29,1.53-3.17,9.18,4.59,12.47,4.59,12.47,3.05-1.88,5.4-.24,5.17,3.41-.24,3.65-3.41,4.59-3.41,4.59-.59,16.22,5.4,18.93,5.4,18.93Z",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.69,136.06c-.17,0-.31-.13-.32-.3,0-.18,.13-.33,.3-.34,3.61-.2,5.03-1.93,5.04-1.95,.11-.14,.31-.16,.45-.05,.14,.11,.16,.31,.06,.45-.06,.08-1.58,1.98-5.51,2.19,0,0-.01,0-.02,0Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.69,132.12l-.59-6.07-2.62,5.52s1.38,1.24,3.21,.55Z",
    fill: "#a02724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.73,126.05c0,.76,.36,1.38,.79,1.38s.79-.62,.79-1.38-.36-1.38-.79-1.38-.79,.62-.79,1.38Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.9,126.05c0,.76,.35,1.38,.79,1.38s.79-.62,.79-1.38-.36-1.38-.79-1.38-.79,.62-.79,1.38Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.97,122.96c-.13,0-.26-.06-.35-.18-.05-.08-1.36-1.84-4.4-1.28-.23,.04-.45-.11-.5-.34-.04-.23,.11-.45,.34-.5,3.6-.66,5.19,1.53,5.25,1.62,.14,.19,.09,.46-.1,.59-.07,.05-.16,.08-.24,.08Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.35,122.44c-.07,0-.13-.01-.19-.05-.21-.11-.29-.36-.19-.57,.95-1.87,3.24-1.59,3.33-1.57,.23,.03,.4,.25,.37,.48-.03,.23-.25,.4-.48,.37-.07,0-1.78-.21-2.46,1.11-.07,.15-.22,.23-.38,.23Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.67,130.78c-2.61,0-4.73-2.12-4.73-4.73s2.12-4.73,4.73-4.73,4.73,2.12,4.73,4.73-2.12,4.73-4.73,4.73Zm0-8.83c-2.26,0-4.09,1.84-4.09,4.1s1.84,4.09,4.09,4.09,4.1-1.84,4.1-4.09-1.84-4.1-4.1-4.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.97,130.78c-2.61,0-4.73-2.12-4.73-4.73s2.12-4.73,4.73-4.73,4.73,2.12,4.73,4.73-2.12,4.73-4.73,4.73Zm0-8.83c-2.26,0-4.09,1.84-4.09,4.1s1.84,4.09,4.09,4.09,4.1-1.84,4.1-4.09-1.84-4.1-4.1-4.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 307.41,
    y1: 126.05,
    x2: 309.23,
    y2: 126.05,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.94
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.39,
    y1: 126.92,
    x2: 327.26,
    y2: 129.05,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.5,145.04s-.92,3.5-2.56,5.91c-.12-2.8-.87-4.98-.87-4.98l3.43-.94Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.54 198.47 302.54 192.14 299.98 197.39 302.54 198.47",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.27 190.02 342.32 178.63 341.77 191.02 344.27 190.02",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.22,213.92c-.13,8.33-3.88,12.48-14.84,13.66-10.96,1.18-29.51-2.53-29.51-2.53-2.36,1.53-7.76,0-7.76,0h-7.42l-2.52-7.34,9.27-2.27,7.42,1.86c11.13,1.52,33.05-1.69,33.05-1.69-.63-4.42-1.34-18.85-1.64-25.59l13.08-3.87c1.29,8.79,.98,20.58,.87,27.77Z",
    fill: "#b55b52"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M164.77,170.42l8.86,45.11c.4,2.02,2.16,3.47,4.22,3.47h74.93c2.68,0,4.71-2.42,4.24-5.06l-8.04-45.11c-.37-2.05-2.15-3.55-4.24-3.55h-75.75c-2.71,0-4.74,2.47-4.22,5.13Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.87,165.28l9.36,53.71h0c1.4,0,2.45-1.26,2.21-2.64l-8.77-49.23c-.19-1.07-1.12-1.85-2.21-1.85h-.59Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.5,223.31h115.24c0-1.19-.49-2.27-1.26-3.04-.78-.78-1.86-1.26-3.04-1.26h-106.61c-2.39,0-4.32,1.93-4.32,4.31Z",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.67,223.31h38.07c0-1.19-.49-2.27-1.26-3.04-.78-.78-1.86-1.26-3.04-1.26h-29.44c-2.39,0-4.32,1.93-4.32,4.31Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.73,193.82c.81,5.61,4.69,9.7,8.67,9.13,3.98-.57,6.55-5.59,5.75-11.2-.81-5.61-4.69-9.7-8.67-9.13-3.98,.57-6.55,5.59-5.75,11.2Z",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.5,223.31h115.24c0-1.19-.49-2.27-1.26-3.04-.78-.78-1.86-1.26-3.04-1.26h-106.61c-2.39,0-4.32,1.93-4.32,4.31Z",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.3,228.89h199c0-3.93-3.19-7.12-7.12-7.12H134.43c-3.93,0-7.12,3.19-7.12,7.12h0Z",
    fill: "#263238"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingMessageVector);
export default __webpack_public_path__ + "static/media/PendingMessageVector.6719f35fc3ee5d78c5d41e3bdcafade6.svg";
export { ForwardRef as ReactComponent };